import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Module-level cache of the salon's default country code.
 * Lazy-loaded once and reused across every PhoneInput on the page.
 * Settings page invalidates it via clearSalonCache() after a successful save
 * so subsequent PhoneInputs reflect the new default immediately.
 */
let _salon = null;
let _inflight = null;
const _subscribers = new Set();

async function fetchSalon() {
  if (_salon) return _salon;
  if (_inflight) return _inflight;
  _inflight = api.get("/salon").then(({ data }) => {
    _salon = data;
    _inflight = null;
    _subscribers.forEach((cb) => cb(_salon));
    return _salon;
  }).catch((e) => {
    _inflight = null;
    throw e;
  });
  return _inflight;
}

export function clearSalonCache() {
  _salon = null;
  fetchSalon().catch(() => {});
}

export function useSalon() {
  const [salon, setSalon] = useState(_salon);
  useEffect(() => {
    let active = true;
    if (!_salon) {
      fetchSalon().then((s) => { if (active) setSalon(s); }).catch(() => {});
    }
    const sub = (s) => active && setSalon(s);
    _subscribers.add(sub);
    return () => {
      active = false;
      _subscribers.delete(sub);
    };
  }, []);
  return salon;
}
